import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { motion } from "framer-motion";

const RoiHeroSection = () => {
  return (
    <Box
      sx={{
        width: "100%",
        pt: { xs: 5, md: 8 },
        pb: { xs: 2, md: 3 },
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* soft background glows */}
      <Box
        sx={{
          position: "absolute",
          top: "-120px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "600px",
          height: "300px",
          background: "radial-gradient(circle, rgba(64,123,255,0.10) 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />

      <Container maxWidth="md" sx={{ px: { xs: 2, sm: 3 }, position: "relative", zIndex: 1 }}>
        {/* Badge */}
        <Typography
          component={motion.div}
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          sx={{
            display: "inline-block",
            color: "#4673D9",
            fontFamily: "Inter, sans-serif",
            fontSize: { xs: "10px", sm: "11px", md: "12px" },
            fontWeight: 600,
            mb: { xs: 2, md: 2.5 },
            letterSpacing: "3px",
            textTransform: "uppercase",
            padding: { xs: "6px 12px", md: "8px 16px" },
            backgroundColor: "rgba(70,115,217,0.08)",
            borderRadius: "6px",
            border: "1px solid rgba(70,115,217,0.15)",
          }}
        >
          Patient Retention ROI Calculator
        </Typography>

        {/* Heading */}
        <Typography
          component={motion.h1}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          sx={{
            background: "linear-gradient(135deg, #1D47A4 0%, #4673D9 50%, #6E91EB 100%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontFamily: "Poppins, sans-serif",
            fontSize: { xs: "30px", sm: "40px", md: "52px" },
            fontWeight: 700,
            mb: { xs: 2, md: 2.5 },
            lineHeight: { xs: "1.2", md: "1.1" },
            letterSpacing: { xs: "-0.02em", md: "-0.03em" },
          }}
        >
          Calculate Your True Patient Retention ROI
        </Typography>

        {/* Subtext */}
        <Typography
          component={motion.p}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          sx={{
            color: "#4B5563",
            fontFamily: "Inter, sans-serif",
            fontSize: { xs: "15px", sm: "16px", md: "18px" },
            fontWeight: 400,
            lineHeight: { xs: "26px", md: "30px" },
            maxWidth: "720px",
            margin: "0 auto",
          }}
        >
          Discover how moving beyond static PDFs to interactive{" "}
          <Box component="span" sx={{ fontWeight: 600, color: "#1D47A4" }}>
            Smart Reports
          </Box>{" "}
          builds unmatched patient trust. Adjust your current lab metrics below to
          visualize the direct revenue impact of retaining more patients.
        </Typography>
      </Container>
    </Box>
  );
};

export default RoiHeroSection;
